import { LaunchCalendlyModalModule } from 'components/calendlyLauncher/calendlyLaunch.service';
import './calendlyButton.scss';

export const CalendlyButtonComponentModule = angular
    .module('app.components.pageHeader.calendlyButton', [
        LaunchCalendlyModalModule
    ])
    .component('calendlyButton', {
        template: `
            <md-button
                ng-click="$ctrl.showCalendly()"
                class="calendly-button">
                <md-icon ng-show="$ctrl.showIcon">phone</md-icon>
                {{"HELP_ACTIONS.CALL" | translate}}
            </md-button>
        `,
        bindings: {
            showIcon: '<'
        },
        controller: class CalendlyButtonCtrl {
            constructor(
                launchCalendlyModal
            ) {
                'ngInject';

                angular.extend(this, {
                    launchCalendlyModal
                });
            }

            showCalendly() {
                this.launchCalendlyModal.openSupportScheduler();
            }
        }
    }).name;



// WEBPACK FOOTER //
// ./src/app/components/pageHeader/calendlyLauncher/calendlyButton.js